<template>
  <div
  id="gkNav"
  :gkheader-size="size"
  :class="['common-header', themeDynamic, rootClass, `common-header_${rootPosition}`]"
  :style="{'top':`${stickyInfo.isOn?stickyInfo.top:0}px`}">
    <div class="common-header-wrapper" :class='[rootWrapClass]'>
      <!-- 移动端左边插槽，有插槽无汉堡包 -->
      <slot name="left">
        <div class="icon-mobile" @click="isMenuMobileShow = !isMenuMobileShow" :class="{'is-active': isMenuMobileShow}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </slot>
      <a class="common-logo" :href='logoHref || "https://geekbang.org/"' :style="{ backgroundImage: `url(${logoImageApply})` }"></a>
      <div class="info" :class="{'is-near-logo-info':pcMenuIsNearLogoInfo}">
        <div class="menu">
          <template v-if="showMenu">
            <div class="menu-item" :class='[menuHoverClass, {hidden: !showMenu}, {on: location.pathname === item.link}]' v-for="(item, i) in menu" :key='i'  @mouseenter="touchMenuStatus = `menu_${i}`" @mouseleave="touchMenuStatus = ''">
              <span class="menu-link" @click="menuClick(item, $event)">
                {{ item.name }}
                <img class="menu-hot" v-if="item.hot" src="https://static001.geekbang.org/static/time/img/geek_elements/hot.png" alt="hot"></span>
              <!-- <span>{{ item.name }}</span> -->
              <transition name="slide-in">
                <ul class="slide-wrap" :class="[themeDynamic]" v-if="item.subMenu && item.subMenu.length > 0 && touchMenuStatus === `menu_${i}`">
                <!-- <ul class="slide-wrap" :class="[themeDynamic]"> -->
                  <li v-for="(slideItem, index) in item.subMenu" :key="index"><span class="slide-wrap-span" @click="menuClick(slideItem, $event)">{{slideItem.subName}}</span></li>
                </ul>
              </transition>
            </div>
          </template>
        </div>
        <slot name="login-section">
          <div class="userinfo">
            <a class="pc-search"><slot name='search'></slot></a>
            <span v-if="!loginUser.nick" class="control">
              <a class="pc" :href="`https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(location)}`">
                登录
              </a>
              <a class='pc line'>|</a>
              <a class="pc" :href="`https://account.geekbang.org/infoq/signup?redirect=${encodeURIComponent(location)}`">
                注册
              </a>
              <a class="mobile" :href="`https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(location)}`">
                登录
              </a>
            </span>
            <!-- <a v-else href="//account.geekbang.org/dashboard" class="profile"></a> -->
            <div v-else class="profile" @mouseenter="touchMenuStatus = 'menu_-1'" @mouseleave="touchMenuStatus = ''">
              <!-- <a href="https://account.geekbang.org/dashboard"> -->
              <i v-if="!isMobile" class="iconfont icon-profile">&#xe60a;</i>
              <!-- </a> -->
              <transition name="slide-in">
                <div class="profile-dropdown" v-if="touchMenuStatus === 'menu_-1'">
                  <i class='arrow'></i>
                  <a href="//account.geekbang.org/dashboard/info" target="_blank" class="navbar-item user-info">
                    <span class="username">{{ tgoUserInfo.name || loginUser.nick }}</span>
                    <span class="cellphone">{{ tgoUserInfo.phone || loginUser.cellphone }}</span>
                  </a>
                  <a href="/dashbord/info" target="_blank" class="navbar-item" v-if="showDashboardInfo">
                    <i class="iconfont">&#xe61b;</i>
                    个人中心
                  </a>
                  <!-- <a href="//time.geekbang.org/dashboard/usercenter" class="navbar-item"> -->
                  <a href="//tgo.infoq.cn/dashbord/group" target="_blank" class="navbar-item">
                    <i class="iconfont">&#xe61d;</i>
                    <!-- 极客时间 -->
                    我的小组
                  </a>
                  <!-- <a :href="`//www.infoq.cn/profile/${loginUser.uid}/`" class="navbar-item"> -->
                  <a href="//tgo.infoq.cn/dashbord/activity" target="_blank" class="navbar-item">
                    <i class="iconfont">&#xe61c;</i>
                    <!-- InfoQ -->
                    我的活动
                  </a>
                  <!-- <a :href="`//account.infoq.cn/logout?redirect=${encodeURIComponent(location)}`" class="navbar-item exit"> -->
                  <a class="navbar-item exit" @click="$emit('logout')">
                    <i class="iconfont">&#xe61a;</i>
                    退出登录
                  </a>
                  <!-- <span class="navbar-item exit" @click="$emit('logout')">
                    <i class="iconfont">&#xe64b;</i>
                    退出登录
                  </span> -->
                </div>
              </transition>
            </div>
          </div>
        </slot>
      </div>
      <div v-if="isMenuMobileShow" class="menu-mobile" :class="{'scrollY':mobileLayoutStyle}" @click.self="blackCover" v-fixed>
        <ul>
          <li class="menu-mobile-li" v-for="(item, i) in menu" :class='{hidden: !showMenu}' :key="i">
            <span class="" @click="menuClick(item, $event)">{{ item.name }}</span>
            <i class="iconfont jiantou" :class="{'is-fold': foldInfo[i]}" @click="switchMenu(i)" v-if="item.subMenu">&#xe62d;</i>
            <div class="submenu-wrapper" v-if="item.subMenu && foldInfo[i]">
              <div class="submenu-item" v-for="(each, k) in item.subMenu" :key="k">
                 <span class="submenu-link" @click="menuClick(each, $event)">{{ each.subName }}</span>
              </div>
            </div>
          </li>
          <slot name='searchmobile'></slot>
          <!-- 退出按钮 -->
          <div @click="$emit('logout')">
            <Button>退出登录</Button>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../base/ego-button-new'
export default {
  props: {
    size: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'white' // white, black, opacity
    },
    showMenu: {
      type: Boolean,
      default: true
    },
    loginUser: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tgoUserInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    logout: {
      type: Function,
      default: null
    },
    rootPosition: {
      type: String,
      default: 'static' // fixed absolute
    },
    rootClass: {
      type: String,
      default: null
    },
    rootWrapClass: {
      type: Array,
      default: () => []
    },
    logoImage: {
      type: Object,
      default: () => ({ white: '', black: '' })
    },
    logoHref: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: true
    },
    /**
     * 移动端导航栏展示的样式
     */
    mobileLayoutStyle: {
      type: String,
      default: '' // scrollY 可纵向滚动
    },
    /**
     * pc端 菜单是否靠近logo，即靠右
     */
    pcMenuIsNearLogoInfo: {
      type: Boolean,
      default: false
    },
    /**
     * 菜单项
     */
    menu: {
      type: Array,
      default: () => {
        return []
      }
    },
    /**
     * 粘滞信息
     */
    stickyInfo: {
      type: Object,
      default: () => {
        return {
          isOn: false,
          isSwitchTheme: false,
          triggerScrollTop: 0,
          top: 0,
          switchTheme: 'white' // 吸顶时主题
        }
      }
    },
    menuHoverClass: {
      type: String,
      default: () => {}
    },
    menuClick: {
      type: Function,
      default: function () { return this.menuClickFn(...arguments) }
    },
    showDashboardInfo: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      touchMenuStatus: '',
      isMenuMobileShow: false,
      themeDynamic: this.theme,
      foldInfo: {} // 折叠信息
    }
  },
  components: {
    Button
  },
  computed: {
    location () {
      return window.location.href
    },
    logoImageApply () {
      return this.themeDynamic !== 'white' ? this.logoImage.white : this.logoImage.black
    }
  },
  watch: {
    // isMenuMobileShow (newVal) {
    //   if (newVal) {
    //     document.documentElement.style.height = '100%'
    //     document.body.style.height = '100%'
    //     document.body.style.overflow = 'hidden'
    //     document.documentElement.removeAttribute('style')
    //     document.body.removeAttribute('style')
    //   }
    // }
    stickyInfo: {
      handler: function (newVal) {
        if (newVal.isOn) {
          this.listenerScroll()
          window.addEventListener('scroll', this.listenerScroll)
        }
      },
      immediate: true
    },
    menu: {
      handler: function (newVal) {
        newVal.forEach((element, index) => {
          this.$set(this.foldInfo, index, true)
        })
      },
      immediate: true
    }
  },
  methods: {
    blackCover () {
      this.$emit('blackClick')
    },
    isOutlink (url) {
      if (!url) return true
      return url.indexOf('http') === 0
    },
    scrollToAnchor () {
      if (!window.location.hash) return
      let gkconNav = document.querySelector('#gkNav')
      if (!gkconNav) return
      let offset = -gkconNav.offsetHeight
      if (document.querySelector(window.location.hash)) {
        this.$scrollTo(window.location.hash, 500, { offset })
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo(window.location.hash, 500, { offset })
          }, 800)
        })
      }
    },
    menuClickFn ({ link = '' }, $event) {
      this.isMenuMobileShow = false

      if (!link) return

      if (this.isOutlink(link)) {
        window.location.href = link

        if (link.indexOf('#') > -1) this.scrollToAnchor()
      } else {
        if (link.indexOf('#') === -1 && link !== window.location.pathname) {
          const { href } = this.$router.resolve({ path: link })
          window.open(href)
        } else {
          // console.log('222')
          // console.log(link)
          this.$router.replace(link, () => {
            if (link.indexOf('#') > -1) this.scrollToAnchor()
          })
        }
      }
    },
    listenerScroll () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let commonHeader = null

      if (this.stickyInfo.triggerScrollTop < scrollTop) {
        this.themeDynamic = this.stickyInfo.switchTheme

        this.$nextTick(() => {
          commonHeader = commonHeader || document.querySelector('.common-header')

          commonHeader && commonHeader.classList.add(this.rootPosition === 'static' ? 'common-header-scroll_sticky' : 'common-header-scroll_fixed')
          if (this.stickyInfo.isSwitchTheme) commonHeader && commonHeader.classList.add('common-header_compact')
        })
      } else {
        this.themeDynamic = this.theme

        this.$nextTick(() => {
          commonHeader = commonHeader || document.querySelector('.common-header')

          commonHeader && commonHeader.classList.remove(this.rootPosition === 'static' ? 'common-header-scroll_sticky' : 'common-header-scroll_fixed')
          if (this.stickyInfo.isSwitchTheme) commonHeader && commonHeader.classList.remove('common-header_compact')
        })
      }
    },
    switchMenu (i) {
      // this.foldInfo[i] = !this.foldInfo[i]
      this.$set(this.foldInfo, i, !this.foldInfo[i])
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/bulma/app.sass";

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
.hidden{
  display: none;
}

.common-header {
  height: 4.75rem;
  background-color: #fff;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  border-bottom: 1px solid #eaeaea;
  z-index: 1000;
  transition: all 0.3s ease-in-out;

  &.common-header_fixed {
    position: fixed; left: 0; right: 0;
  }

  &.common-header_absolute {
    position: absolute; left: 0; right: 0;
  }

  &.common-header_sticky {
    position: sticky; left: 0; right: 0;
  }

  &.common-header-scroll_fixed {
    position: fixed; left: 0; right: 0;
    box-shadow: 0 2px 6px rgba(#000, 0.1);
  }

  &.common-header-scroll_sticky {
    position: sticky; left: 0; right: 0;
    box-shadow: 0 2px 6px rgba(#000, 0.1);
  }

  &.common-header_compact {
    height: calc(4.75rem - 15px);

    .slide-wrap {
      top: calc(4.9rem - 15px) !important;
    }
  }

  .common-header-wrapper {
    width: 88vw;
    min-width: 1080px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    @media screen and (max-width: 768px) {
      min-width: auto;
    }
    .icon-mobile,
    .menu-mobile {
      display: none;
    }

    .common-logo {
      flex-shrink: 0;
      width: 9.4375rem;
      // height: 4.75rem;
      margin-right: 2.5rem;
      background-image: url('https://static001.geekbang.org/static/www/img/logo1.b8d5e40.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
      &.is-near-logo-info {
        flex: 1;
        justify-content: space-between;
      }
      .menu {
        display: flex;
        flex: 1 0;
        height: 100%;
        .menu-item {
          position: relative;
          transition: color 0.2s ease;
          display: flex; align-items: center;
          cursor: pointer;
          white-space: nowrap;
          &:hover {
            color: $primary;
            // .slide-wrap {
            //   display: block;
            // }
            &::before {
              content: '';
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              width: 40%;
              height: 2px;
              background: $primary;
              bottom: 13px;
            }

          }

          .menu-link {
            position: relative;
            // padding: 0 1.1rem;
            padding: 0 10px;
            font-weight: 400;
            // line-height: 4.75rem;
            color: #353535;
            &.on {
              color: $primary;
            }
            &:hover {
              color: $primary;
            }

            .menu-hot {
              position: absolute;
              width: 20px;
              height: 12px;
              right: -4px;
              top: 0;
            }
          }

          & .slide-wrap {
            // display: none;
            display: block;
            position: absolute; left: 50%; top: 4.9rem; z-index: 100000;
            transform: translateX(-50%);
            padding: 30px;
            padding-bottom: 0;
            box-sizing: border-box;
            background: #0D0D0D;
            margin-top: 6px;
            border-radius: 3px;
            white-space: nowrap;
            &::before {
              content: '';
              position: absolute;
              width: 100%;
              height: 30px;
              top: -20px;
              left: 0;
            }
            li {
              margin-bottom: 30px;
              line-height: 1;
              .slide-wrap-span {
                padding: 0;
                color: #fff;
                opacity: .6;
                transition: opacity 0.2s ease;
                word-break: keep-all;
                &:hover {
                  color: #fff;
                  opacity: 1;
                }
              }
            }
            &.white {
              background: #fff;
              // color: #353535;
              box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
              li {
                .slide-wrap-span {
                  color: #353535;
                  &:hover {
                    color: $primary;
                  }
                }
              }
            }
          }

          &.on {
            color: $primary;
            &::before {
              content: '';
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              width: 40%;
              height: 2px;
              background: $primary;
              bottom: 13px;
            }

            .menu-link {
              color: $primary;
            }
          }
        }
      }

      .userinfo {
        // height: 4.75rem;
        line-height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        padding-left: 1.1rem;
        .control {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          a {
            font-size: 1rem;
            color: #353535;
            display: block;
            // height: 4.75rem;
            // line-height: 4.75rem;
            &.mobile {
              display: none;
            }

            &.line {
              font-size: 1.2rem;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
            }
          }
        }

        .pc-search {
          @media all and (max-width: 768px) {
            display: none;
          }
        }

        .profile {
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center;
          position: relative;
          cursor: pointer;
          .profile-dropdown {
            // visibility: hidden;
            display: flex;
            position: absolute;
            width: 152px;
            flex-direction: column;
            // box-shadow: 0 4px 42px 6px rgba(10, 10, 10, 0.1);
            box-shadow:0px 3px 10px 4px rgba(139,162,192,0.13);
            top: 45px;
            right: -16px;
            border-radius: 6px;
            z-index: 200000;
            transition: all .2s ease;
            .arrow {
              box-shadow:0px 0px 8px 3px rgba(139,162,192,0.13);
              cursor: pointer;
              width: 10px;
              height: 10px;
              background-color: #ffffff;
              transform: rotate(45deg);
              position: absolute;
              right: 25px;
              top: -5px;
            }
            .navbar-item {
              background-color: #fff;
              height: 48px;
              // font-size: 1.125rem;
              font-size: 16px;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              padding: 0 20px;
              color: #353535;
              cursor: pointer;
              position: relative;
              z-index: 1;
              box-sizing: border-box;
              font-weight: 400;
              overflow: hidden;
              // transition: height .2s ease;

              &.user-info{
                height: 64px;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                border-bottom: 1px solid #E9E9E9;
                border-radius: 6px 6px 0 0;
                .username{
                  font-size: 14px;
                  color: #404040;
                  font-weight: 400;
                  line-height: 1em;
                  @include limit-line-numbers(1);
                }
                .cellphone{
                  margin-top: 7px;
                  line-height: 1em;
                  font-size: 12px;
                  color: #b2b2b2;
                  font-weight: 400;
                }
              }

              &:hover {
                background: #F6F7FB;
                // color: $primary;
                .icon-font, .iconfont {
                  // color: $primary;
                }
              }
              .icon-font, .iconfont {
                display: inline-block;
                width: 16px;
                text-align: center;
                margin-left: 1px;
                font-size: 16px;
                // color: #999;
                color: #353535;
                margin-right: 13px;
              }
              &.router-link-active{
                color: $primary;
                .icon-font, .iconfont {
                  color: $primary;
                }
              }
              &:last-child {
                border-bottom: none;
              }
              &.exit{
                border-top: 1px solid #E9E9E9;
                border-radius: 0 0 6px 6px;
              }
            }
          }
        }

        i.icon-profile {
          color: #888;
          font-size: 1.5rem;
          display: block;
        }
      }
    }
  }
  // 透明主题
  &.opacity {
    background-color: transparent;
    border-bottom: none;
    .common-header-wrapper {
      .icon-mobile{
        span{
          background-color: #ffffff;
        }
      }
      .common-logo {
        background-image: url(https://static001.geekbang.org/static/live/img/logo.bb6fd3f.png);
      }
      .info {
        .menu {
          .menu-link{
            color: #fff;
            &:hover {
              // color: $primary;
            }
          }
        }
        .userinfo{
          .control{
            a{
              color: #fff;
            }
          }
        }
        .profile {
          i.icon-profile{
            color: #fff;
          }
        }
      }
    }
  }
  // 黑色主题
  &.black {
    background-color: #0D0D0D;
    border-bottom: none;
    .common-header-wrapper {
      .icon-mobile{
        span{
          background-color: #ffffff;
        }
      }
      .common-logo {
        background-image: url(https://static001.geekbang.org/static/live/img/logo.bb6fd3f.png);
      }
      .info {
        .menu {
          .menu-link {
            color: #fff;
            &:hover {
              color: $primary;
            }
          }
        }
        .userinfo{
          .control{
            a{
              color: #fff;
            }
          }
        }
        .profile {
          i.icon-profile{
            color: #fff;
          }
          .profile-dropdown {
            background-color: #1e1e1e;
            box-shadow: 0px 3px 10px 4px rgba(139,162,192,0.3);
            .arrow {
              box-shadow: 0px 0px 8px 3px rgba(139,162,192,0.2);
              background-color: #1e1e1e;
            }
            .navbar-item {
              background-color: #1e1e1e;
              &:link,
              &:visited {
                color: #fff;
              }
              &:hover {
                // color: $primary;
                background-color: #353535;
              }
              .icon-font, .iconfont {
                color: #888;
                // font-size: 1.25rem;
              }
              &.user-info {
                border-color: #353535;
                .username{
                  color: #b2b2b2;
                }
              }
              &.exit {
                border-color: #353535;
              }
            }
          }
        }
      }
    }
  }
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.3s ease;
}
.slide-in-enter,
.slide-in-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}

@media all and (max-width: 960px) {
  .common-header .common-header-wrapper .info .menu a{
    padding: 0.5rem 0.5rem;
  }
}
@media all and (max-width: 835px) {
  .common-header .common-header-wrapper .info .menu a{
    padding: 0.5rem 0.25rem;
  }
}
@media all and (max-width: 768px) {
  .common-header {
    height: 3rem;
    border-bottom: none;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
    // z-index: 1;
    background-color: #fff;

    &.common-header_compact {
      height: 3rem;
    }
    .common-header-wrapper {
      width: 96vw;
      align-items: center;
      .icon-mobile {
        display: block;
        position: relative;
        cursor: pointer;
        width: 1rem;
        height: 1rem;
        span {
          display: inline-block;
          position: absolute;
          width: 16px;
          height: 1px;
          background-color: #000;
          transition: all .35s;
          left: 0;
          &:nth-child(1) {
            top: 2px;
          }
          &:nth-child(2) {
            top: 8px;
          }
          &:nth-child(3) {
            top: 14px;
          }
        }
        &.is-active{
          z-index: 11;
          span{
            background-color: #fff;
            &:nth-child(1) {
              transform-origin: left top;
              transform: rotate(45deg);
            }
            &:nth-child(2) {
              display: none;
            }
            &:nth-child(3) {
              top: 13px;
              transform-origin: left bottom;
              transform: rotate(-45deg);
            }
          }
        }
      }
      .menu-mobile {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .9);
        z-index: 10;
        align-items: center;
        &.scrollY {
          align-items: flex-start;
          overflow-y: scroll;
          overflow-x: hidden;
          ul {
            padding: 14vh 0;
            margin-top: 0;
          }
        }
        ul {
          margin: 0 2.5rem;
          margin-top: -4vh;
          width: 100%;
          list-style: none;
          list-style-position: inside;
          padding: 0;
          li{
            line-height: 1.5;
            padding: 1rem 0.2rem .6rem;
            border-bottom: 1px solid #353535;
            font-size: 1rem;
            text-align: left;
            font-size: 14px;
            span {
              color: #fff;
            }

            // 箭头
            .jiantou {
              display: inline-block;
              color: #fff;
              font-size: 12px;
              margin-left: 10px;
              &.is-fold {
                transform: rotateZ(-180deg);
              }
            }

            // 子菜单
            .submenu-wrapper {
              margin-top: 14px;
              margin-left: 15px;
              .submenu-item {
                padding-bottom: 8px;
                margin-bottom: 10px;
                border-bottom: 1px solid #353535;
                &:last-child {
                  padding-bottom: 0;
                  margin-bottom: 0;
                  border: none;
                }
                .submenu-link {
                }
              }
            }
          }
        }
      }

      .common-logo {
        width: 4.90625rem;
        height: 1.25rem;
        position: absolute;
        left: 50%;
        top: 1rem;
        transform: translate(-50%);
      }
      .info {
        height: 100%;
        justify-content: flex-end !important;
        .menu {
          display: none;
        }
        .userinfo {
          height: 100%;
          .control {
            height: 100%;
            a {
              &.mobile {
                display: inline-block;
                // margin-right: 0.5rem;
                font-size: 0.875rem;
              }
              &.pc {
                display: none;
              }
            }
          }
          .profile {
            &:hover {
              .profile-dropdown {
                display: none;
              }
            }
          }
          i.icon-profile {
            font-size: 1rem;
          }
        }
      }
    }
  }
}
::v-deep .ego-button{
  margin: 0 auto;
  margin-top: 20px;
  width: 230px; height: 40px;
  font-size: 16px;
  // border: 1px solid #FFFFFF;
  // color:#FFFFFF !important;
}
</style>
